var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(
            _vm.$ct("rename-ledger-account-code", { code: _vm.value.Code })
          )
        ),
      ]),
      _c(
        "w-card-content",
        [
          _vm.tabs.length > 0
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tab == 0
            ? [
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input", {
                          attrs: {
                            label: _vm.$ct("ledger-account-description"),
                            required: "",
                          },
                          model: {
                            value: _vm.input,
                            callback: function ($$v) {
                              _vm.input = $$v
                            },
                            expression: "input",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("app-select-ledger-account-vat-field", {
                          attrs: { label: _vm.$ct("ledger-account-vat-field") },
                          model: {
                            value: _vm.vatField,
                            callback: function ($$v) {
                              _vm.vatField = $$v
                            },
                            expression: "vatField",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-select", {
                          attrs: {
                            items: _vm.balansItems,
                            label: _vm.$ct("ledger-account-cols.balans"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.balans,
                            callback: function ($$v) {
                              _vm.balans = $$v
                            },
                            expression: "balans",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-select", {
                          attrs: {
                            items: _vm.typeItems,
                            label: _vm.$ct("ledger-account-cols.type"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.ledgerType,
                            callback: function ($$v) {
                              _vm.ledgerType = $$v
                            },
                            expression: "ledgerType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input-autocomplete", {
                          attrs: {
                            label: _vm.$ct("ledger-account-cols.group"),
                            fancy: "",
                            "has-error":
                              _vm.groupCodeFocused && !_vm.groupCodeValid,
                            items: _vm.groupCodeItems,
                            open: "",
                          },
                          on: {
                            "item-click": function ($event) {
                              return _vm.onGroupClick($event)
                            },
                            blur: function ($event) {
                              return _vm.onGroupBlur()
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _c("div", { staticClass: "code" }, [
                                        _vm._v(
                                          " " + _vm._s(scope.item.Code) + " "
                                        ),
                                      ]),
                                      _c("div", { staticClass: "name" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.item.Description) +
                                            " "
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2376827673
                          ),
                          model: {
                            value: _vm.groupCode,
                            callback: function ($$v) {
                              _vm.groupCode = $$v
                            },
                            expression: "groupCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.tab == 1
            ? _c("app-extra-fields-edit", {
                attrs: {
                  "name-settings": _vm.extraFieldNames,
                  value: _vm.value.ExtraFields,
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }